import { PlanogramPegboard, PlanogramPegboardNonCircular } from "./pegboard";
import { Planogram } from "./planogram";
import { PlanogramShelf, PlanogramShelfNonCircular } from "./shelf";

interface PlanogramBayCommon {
  uniqueId: string;
  width: number;
  height: number;
  depth: number;
  baseHeight: number;
  notchOffset: number;
  notchSpacing: number;
  maxNotch: number;
  maxShelfHeight: number;
  maxProductHead: number;
}

export interface PlanogramBayNonCircular extends PlanogramBayCommon {
  shelves: PlanogramShelfNonCircular[];
  pegboards: PlanogramPegboardNonCircular[];
}

export class PlanogramBay implements PlanogramBayCommon {
  uniqueId: string;
  width: number;
  height: number;
  depth: number;
  baseHeight: number;
  notchOffset: number;
  notchSpacing: number;
  maxNotch: number;
  maxShelfHeight: number;
  maxProductHead: number;

  shelves: PlanogramShelf[];
  pegboards: PlanogramPegboard[];
  planogram: Planogram;

  constructor(bay: PlanogramBayNonCircular, planogram: Planogram) {
    this.uniqueId = bay.uniqueId;
    this.width = bay.width;
    this.height = bay.height;
    this.depth = bay.depth;
    this.baseHeight = bay.baseHeight;
    this.notchOffset = bay.notchOffset;
    this.notchSpacing = bay.notchSpacing;
    this.maxNotch = bay.maxNotch;
    this.maxProductHead = bay.maxProductHead;
    this.maxShelfHeight = bay.maxShelfHeight;
    this.shelves = bay.shelves.map((shelf) => new PlanogramShelf(shelf, this));
    this.pegboards = bay.pegboards.map((pegboard) => new PlanogramPegboard(pegboard, this));
    this.planogram = planogram;
  }

  getNo = () => {
    return this.planogram.bays.findIndex((bay) => bay.uniqueId === this.uniqueId) + 1;
  };

  getXLeft = () => {
    let xLeft = 0;

    for (const bay of this.planogram.bays) {
      if (bay.uniqueId === this.uniqueId) {
        break;
      }

      xLeft += bay.width;
    }

    return xLeft;
  };

  getXRight = () => {
    return this.getXLeft() + this.width;
  };

  fixShelvesOrder = () => {
    this.shelves = this.shelves.sort((shelf1, shelf2) =>
      shelf1.getNotchNo() > shelf2.getNotchNo() ? -1 : 1,
    );
  };

  addShelf = (shelf: PlanogramShelf) => {
    this.shelves.push(shelf);
    this.fixShelvesOrder();
    return shelf;
  };

  addPegboard(pegboard: PlanogramPegboard) {
    this.pegboards.push(pegboard);
    return pegboard;
  }

  delete = () => {
    for (const shelf of this.shelves) {
      shelf.delete();
    }

    this.planogram.bays = this.planogram.bays.filter((bay) => bay.uniqueId !== this.uniqueId);
  };
}
